import React from 'react';
import {
  Col,
  Row
} from "reactstrap";
import {faEnvelope, faMobile, faPhone, faUser} from "@fortawesome/free-solid-svg-icons";
import Contact from "../../../Models/Contact";
import InputComponent from "../Inputs/InputComponent";
import {emailPattern} from "../../../Utils/Utils";

interface IProps {
  contact?: Contact;
}

const ContactFormComponent = ({ contact }: IProps) => {

  return (
    <>
      <Row>

        <Col md="6" lg="4" sm="12">
          <InputComponent
            label="NOMBRES"
            icon={faUser}
            name="contact_name"
            defaultValue={contact?.last_name}
            required
            minLength={4}
          />
        </Col>

        <Col md="6" lg="4" sm="12">
          <InputComponent
            label="APELLIDOS"
            icon={faUser}
            name="contact_last_name"
            defaultValue={contact?.last_name}
            required
            minLength={4}
          />
        </Col>

        <Col md="6" lg="4" sm="12">
          <InputComponent
            label="CELULAR"
            icon={faMobile}
            name="contact_cellphone"
            defaultValue={contact?.cellphone}
            type="number"
            minLength={10}
            maxLength={10}
          />
        </Col>

        <Col md="6" lg="4" sm="12">
          <InputComponent
            label="TELÉFONO"
            icon={faPhone}
            name="contact_phone"
            defaultValue={contact?.phone}
            type="number"
            required
            minLength={7}
            maxLength={10}
          />
        </Col>

        <Col md="6" lg="4" sm="12">
          <InputComponent
            label="CORREO ELECTRONICO"
            icon={faEnvelope}
            name="contact_email"
            defaultValue={contact?.email}
            type="email"
            pattern={emailPattern}
          />
        </Col>

      </Row>
    </>
  );
};
export default ContactFormComponent;
